import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, FileText, Shield, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HowItWorks = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const steps = [
    {
      number: '1',
      icon: MapPin,
      title: t('step1Title'),
      description: t('step1Desc')
    },
    {
      number: '2',
      icon: FileText,
      title: t('step2Title'),
      description: t('step2Desc')
    },
    {
      number: '3',
      icon: Shield,
      title: t('step3Title'),
      description: t('step3Desc')
    },
    {
      number: '4',
      icon: CheckCircle,
      title: t('step4Title'),
      description: t('step4Desc')
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('howItWorks')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('howItWorksSubtitle')}
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                className="relative text-center group"
              >
                {/* Connector Line (hidden on mobile and last item) */}
                {step.number !== '4' && (
                  <div className="hidden lg:block absolute top-16 left-1/2 w-full h-0.5 bg-gradient-to-r from-teal-200 via-teal-300 to-transparent z-0"></div>
                )}

                {/* Step Content */}
                <div className="relative z-10">
                  {/* Number Badge */}
                  <div className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-gradient-to-br from-logo-cyan to-logo-cyan text-white mb-6 shadow-xl group-hover:scale-110 transition-transform duration-300">
                    <div className="text-center">
                      <div className="text-5xl font-bold mb-1">{step.number}</div>
                      <Icon className="w-8 h-8 mx-auto" strokeWidth={2} />
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12">
          <button 
            onClick={() => navigate('/apply')}
            className="bg-gradient-to-r from-logo-blue to-logo-cyan text-white px-10 py-4 rounded-full font-semibold text-lg hover:from-blue-700 hover:to-cyan-700 transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            {t('startApplication')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
